import { t } from '@lingui/macro';
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import React, { memo } from 'react';
import CustomChart from '../components/CustomChart/CustomChart';
import { createCanvas } from '../utils';
import Avatar from '../../../component/Avatar';
import { getPlatformName } from "../../../variables/staticValue";

const getOption = () => ({
  plugins: [ChartAnnotation],
  legend: {
    display: false,
  },
  aspectRatio: 1,
  tooltips: {
    enabled: false,
    position: 'nearest',
    mode: 'nearest',
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    intersect: 0,
  },
  annotation: {
    drawTime: 'beforeDatasetsDraw',
    annotations: [
      {
        type: 'line',
        mode: 'horizontal',
        scaleID: 'y-axis-0',
        value: 0,
        borderColor: '#eeeeee',
        borderWidth: 2,
        borderDash: [3, 3],
      },
    ],
  },
  elements: {
    point: {
      pointStyle: (context) => {
        if (!context) return;
        const { avatar, r } = context?.dataset?.data?.[context.dataIndex] || {};
        return avatar ? createCanvas(r + 5, avatar) : 'circle';
      },
    },
  },
  scales: {
    xAxes: [
      {
        scaleLabel: {
          labelString: t`Tin nhắn`,
        },
        ticks: {
          suggestedMin: 0,
          beginAtZero: true,
          callback: function (value) {
            if (value % 1 === 0) {
              return value;
            }
          },
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          labelString: t`Comment`,
        },
        ticks: {
          suggestedMin: 0,
          beginAtZero: true,
          callback: function (value) {
            if (value % 1 === 0) {
              return value;
            }
          },
        },
      },
    ],
  },
});

const getColumns = () => [
  {
    Header: '',
    accessor: 'avatar',
    className: 'flex-center-row',
    width: 80,
    Cell: ({ value }) => {
      return <Avatar user={{ avatar: value }} size={30} margin={false} />;
    },
  },
  {
    Header: t`Kênh`,
    accessor: 'name',
  },
  {
    Header: t`Loại kênh`,
    accessor: 'channel_type',
    width : 100,
    Cell: (props) => <div>{getPlatformName(props.value)}</div>
  },
  {
    Header: t`Tin nhắn`,
    width: 100,
    accessor: 'x',
  },
  {
    Header: t`Comment`,
    width: 100,
    accessor: 'y',
  },
  {
    Header: t`Tổng cộng`,
    width: 100,
    Cell: (props) => <span>{props.original.x + props.original.y}</span>,
  },
];

const ChannelMessageType = (props) => {
  console.log(props);
  return <CustomChart getOption={getOption} columns={getColumns()} {...props} />;
};

export default memo(ChannelMessageType);
